import { useMinAndMaxPeopleNumPerRoom } from "@/components/features/items/edit/plan/_shared/ui/components/min-and-max-people-num/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanMinAndMaxPeopleNumPerRoom = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { minimumPeopleNumPerRoom, maxPeopleNumPerRoom } = viewModel;

	return useMinAndMaxPeopleNumPerRoom({
		minimumPeopleNumPerRoom,
		maxPeopleNumPerRoom,
		onSetViewModel,
	});
};
